import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { EditableLabelGroup, WrappingBehavior, ILabelModel } from "azure-devops-ui/Label";
import { getSuggestions, labelProps } from "./LabelData";

export default class EditableLabelGroupFreeFlow extends React.Component<{}> {
    private ref: React.RefObject<EditableLabelGroup> = React.createRef<EditableLabelGroup>();

    public render() {
        return (
            <div className="flex-column" style={{ width: 400 }}>
                <EditableLabelGroup
                    ref={this.ref}
                    labelProps={labelProps}
                    wrappingBehavior={WrappingBehavior.freeFlow}
                    getSuggestedLabels={getSuggestions}
                    title={"Labels"}
                    onLabelSubmit={this.onLabelSubmit}
                    onLabelRemove={this.onLabelRemove}
                />
                <Button onClick={this.onButtonClick}>Click to focus</Button>
            </div>
        );
    }

    private onLabelSubmit = (model: ILabelModel) => {
        labelProps.push(model);
    };

    private onLabelRemove = (model: ILabelModel) => {
        labelProps.removeAll(
            (item: ILabelModel) => item.content.toUpperCase() === model.content.toUpperCase()
        );
    };

    private onButtonClick = () => {
        this.ref.current!.focus();
    };
}
